export default {
    account: JSON.parse(localStorage.getItem('account')) || null, // 当前账户

    regionValue: [], // 选中的区域value

    regionName: [], // 选中的区域name

    printFormData: {}, // 当前打印表单数据

    deviceUuid: null
}



// WEBPACK FOOTER //
// ./src/store/state.js